import { RouteRecordRaw } from 'vue-router';
import { ValidityHistoryPage } from '@/pages/validity-history';

export const routeName = 'HistoricoVigencias';

export const route: RouteRecordRaw = {
  path: 'historico-vigencias',
  name: routeName,
  component: ValidityHistoryPage,
  meta: {
    requiresAuth: true,
    breadcrumb: 'Histórico de Vigências',
    permissions: [{ action: 'manage', subject: 'ValidityHistory' }],
  },
};
